import axios from "axios";
import LoadingService from "../service/loadingService";
import ToastService from "../service/toastService";

const AXIOS = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true, // 🔐 envoie les cookies avec chaque requête
});

AXIOS.interceptors.request.use((config) => {
  LoadingService.showLoading();
  return config;
});

const onFulfilled = (response) => {
  LoadingService.hideLoading();
  return response;
};

const onRejected = (error) => {
  LoadingService.hideLoading();

  if (error.response?.status === 401) {
    ToastService.displayErrorToast(
      "Vous devez être connecté pour accéder à cette ressource."
    );
  } else {
    ToastService.displayResponseErrorToast(error.response);
  }

  return Promise.reject(error);
};

AXIOS.interceptors.response.use(onFulfilled, onRejected);

export default AXIOS;
